import { RentalAgreement } from "@/components/RentalAgreement";
import { Reveal } from "@/components/Reveal";

export default function AgreementPage() {
  return (
    <main className="bg-paper pb-28" data-testid="agreement-page">
      <div className="mx-auto max-w-3xl px-4 pt-14 sm:px-8">
        <Reveal>
          <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-900/5 sm:p-12">
            <RentalAgreement />
          </div>
          <p className="mt-6 text-center text-xs text-slate-500">
            This agreement is presented for review and acceptance during checkout, before any payment is taken.
          </p>
        </Reveal>
      </div>
    </main>
  );
}
